import Util from '@/lib/util'
import _ from "lodash";

export default [
    {
        title:Util.L('Order'),
        key:'orderNo',
        width: 80,
        align:"center"
      },
      {
        title:Util.L('Ngày áp dụng cũ'),
        key:'effectiveDateOld',
        width: 100,
        align: 'center',
        render:(h:any,params:any)=> { return h("span", params.row.effectiveDateOld ? Util.toViewDatePickerString(params.row.effectiveDateOld) : null); }
    },
    {
        title:Util.L('Thời gian BH(ngày) cũ'),
        key:'durationOld',
        width: 120,
        align: 'right',
        render:(h:any,params:any)=> { return h("span", Util.toViewNumberString(params.row.durationOld)); }

    },
    {
        title:Util.L('Ngày áp dụng mới'),
        key:'effectiveDate',
        width: 100,
        align: 'center',
        render:(h:any,params:any)=> { return h("span", params.row.effectiveDate ? Util.toViewDatePickerString(params.row.effectiveDate) : null); }
    },
    {
        title:Util.L('Thời gian BH(ngày) mới'),
        key:'duration',
        width: 120,
        align: 'right',
        render:(h:any,params:any)=> { return h("span", Util.toViewNumberString(params.row.duration)); }

    },
    {
        title:Util.L('Người cập nhật'),
        key:'lastModifierUserFullName',
    },
    {
        title:Util.L('Ngày cập nhật'),
        key:'lastModificationTime',
        width: 170,
        render:(h:any,params:any)=> { return h("span",params.row.lastModificationTime ? Util.toViewDateString(params.row.lastModificationTime) : null); }
    }]